// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  PRO_URL: 'https://businessinmaharashtra.com',
  API_URL: 'https://businessinmaharashtra.com/bim/api/',
  IMG_URL:"https://businessinmaharashtra.com/bim/backend/upload/",
  RAZORPAY_KEY_SECRET:"xQ01iveUOcq5kgH1PA6h877q",
  RAZORPAY_KEY_ID:"rzp_test_XAXEprxmmUGHM7"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
